module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="container-fluid">\n	<div class="navbar-header">\n		<a class="navbar-brand aboutVlab" id = "navLogo">\n			<div id = "virtual">Virtual</div>\n			<div id = "lab">Lab</div>\n		</a>\n		<button type="button" class="navbar-toggle" data-toggle="collapse" data-target=".navbar-collapse">\n			<span class="icon-bar"></span>\n			<span class="icon-bar"></span>\n			<span class="icon-bar"></span>\n		</button>\n	</div>\n	<div class="collapse navbar-collapse">\n		<ul class="nav navbar-nav">\n			<li class="dropdown">\n				<a class="dropdown-toggle" data-toggle="dropdown" id="file"> ' +
((__t = (terms.file[language])) == null ? '' : __t) +
' <b class="caret"></b></a>\n				<ul class="dropdown-menu">\n					<li class=\'addWorkbenchButton\'> <a> ' +
((__t = (terms.addNewWorkbench[language])) == null ? '' : __t) +
'</a></li>\n					<li class=\'renameWorkbenchButton\'><a> ' +
((__t = (terms.renameWorkbench[language])) == null ? '' : __t) +
' </a></li>\n					';
 if (allowLoadAssignment) { ;
__p += '\n					<li class="divider"></li>\n					<li id="toAssignmentModal"><a>' +
((__t = (terms.loadAssignment[language])) == null ? '' : __t) +
'</a></li>\n					';
 } ;
__p += '\n				</ul>\n			</li>\n			<li class="dropdown">\n				<a class="dropdown-toggle" data-toggle="dropdown" id="edit"> ' +
((__t = (terms.edit[language])) == null ? '' : __t) +
' <b class="caret"></b></a>\n				<ul class="dropdown-menu">\n					<li><a class=\'removeSolid editItem\'>' +
((__t = (terms.removeSolid[language])) == null ? '' : __t) +
'</a></li>\n					<li><a class=\'removeLiquid editItem\'>' +
((__t = (terms.removeLiquid[language])) == null ? '' : __t) +
'</a></li>\n					<li class=\'divider\'></li>\n					<li><a class=\'duplicateVessel editItem\'>' +
((__t = (terms.duplicate[language])) == null ? '' : __t) +
'</a></li>\n					<li class=\'divider\'></li>\n					<li><a class=\'thermalProperties editItem\'>' +
((__t = (terms.thermalProperties[language])) == null ? '' : __t) +
'</a></li>\n					<li class=\'divider\'></li>\n					<li><a class=\'renameVessel editItem\'>' +
((__t = (terms.rename[language])) == null ? '' : __t) +
'</a></li>\n					<li><a class=\'removeVessel editItem\'>' +
((__t = (terms.remove[language])) == null ? '' : __t) +
'</a></li>\n					<li class="divider"></li>\n					<li><a class="clearWorkbench editItem">' +
((__t = (terms.clearWorkbench[language])) == null ? '' : __t) +
'</a></li>\n				</ul>\n			</li>\n			<li class="dropdown">\n				<a class="dropdown-toggle" data-toggle="dropdown" id="view"> ' +
((__t = (terms.view[language])) == null ? '' : __t) +
' <b class="caret"></b></a>\n				<ul class="dropdown-menu viewerList">\n					<li><a id="presentationMode">' +
((__t = (terms.presentationMode[language])) == null ? '' : __t) +
' <span class="glyphicon glyphicon-ok" aria-hidden="true" style="display:none"></span></a></li>\n					<li class="divider"></li>\n					<li><a id="workbenchZoomOut">' +
((__t = (terms.zoomOut[language])) == null ? '' : __t) +
'</a></li>\n					<li><a id="workbenchZoomIn">' +
((__t = (terms.zoomIn[language])) == null ? '' : __t) +
'</a></li>\n					<li><a id="workbenchResetZoom" style="display:none">' +
((__t = (terms.resetZoom[language])) == null ? '' : __t) +
'</a></li>\n				</ul>\n			</li>\n			<li class="dropdown">\n				<a class="dropdown-toggle" data-toggle="dropdown" id="help"> ' +
((__t = (terms.help[language])) == null ? '' : __t) +
' <b class="caret"></b></a>\n				<ul class="dropdown-menu">\n					<li><a class="aboutVlab helpItem">' +
((__t = (terms.aboutVlab[language])) == null ? '' : __t) +
'</a></li>\n					<li><a class="helpItem" href="http://www.chemcollective.org/chem/common/vlab_walkthrouh_html5.php" target="_blank">' +
((__t = (terms.videoWalkthrough[language])) == null ? '' : __t) +
'</a></li>\n					<li><a class="tips helpItem">' +
((__t = (terms.tips[language])) == null ? '' : __t) +
'</a></li>\n				</ul>\n			</li>\n		</ul>\n		<ul class="nav navbar-nav" style="float:right">\n			<li>\n				<a id="changeLanguage"><span class="glyphicon glyphicon-globe" aria-hidden="true"></span> ' +
((__t = (language.toUpperCase())) == null ? '' : __t) +
'</a>\n			</li>\n			<li>\n				<a id="assignmentName"></a>\n			</li>\n		</ul>\n	</div>\n</div>\n';

}
return __p
}